import { Stack, Typography, styled } from '@mui/material'
import Image from 'next/image'
import React from 'react'
import LogoSvg from '@/assets/imgs/logo.svg'

const TextLogo = styled(Typography)`
  font-weight: 400;
  font-size: 15.2727px;
  line-height: 20px;
  color: #bfff0b;
`

const Logo = () => {
  return (
    <Stack direction={'row'} spacing={8} alignItems={'center'}>
      <Image src={LogoSvg} alt={'logo'} width={28} height={28} />
      <TextLogo variant="h1">MultiBit</TextLogo>
    </Stack>
  )
}

export default Logo
